import { render, staticRenderFns } from "./ParkingComplexesPage.vue?vue&type=template&id=52808a0e"
import script from "./ParkingComplexesPage.vue?vue&type=script&lang=js"
export * from "./ParkingComplexesPage.vue?vue&type=script&lang=js"
import style0 from "./ParkingComplexesPage.vue?vue&type=style&index=0&id=52808a0e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports